module.exports = __webpack_public_path__ + "static/media/home.05653307.svg";